import React, { useEffect, useState, useRef } from "react";
import "./ChangeCourse.scss";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useSearchParams } from "react-router-dom";

const ChangeCourse = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const ChangeCourseModal = searchParams.get("new") === "1";
  const setChangeCourseModal = (open) => {
    const next = new URLSearchParams(searchParams);
    if (open) next.set("new", "1"); else next.delete("new");
    setSearchParams(next, { replace: !open });
  };
  const [data, setData] = useState("");
  const [typeList] = useState([{ id: 1, label: "Beginner", value: "1" },{ id: 2, label: "Intermediate", value: "2" },{ id: 3, label: "Advanced", value: "3" }]);
  const [typeToogle, setTypeToogle] = useState(false);
  const [typeToogleValue, setTypeToogleValue] = useState(null);
  const [typeToogleId, setTypeToogleId] = useState(null);
  const [studentCourseList, setStudentCourseList] = useState([]);
  const [studentCourseToogle, setStudentCourseToogle] = useState(false);
  const [studentCourseToogleValue, setStudentCourseToogleValue] = useState(null);
  const [studentCourseToogleId, setStudentCourseToogleId] = useState(0);
  const [studentFutureCourseList, setStudentFutureCourseList] = useState([]);
  const [studentFutureCourseToogle, setStudentFutureCourseToogle] = useState(false);
  const [studentFutureCourseToogleValue, setStudentFutureCourseToogleValue] = useState(null);
  const [studentFutureCourseToogleId, setStudentFutureCourseToogleId] = useState(null);
  const [selectDate, setSelectDate] = useState("");
  const [catalogLoading, setCatalogLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [review, setReview] = useState(null);
  const inFlight = useRef(false);
  const catalogVersion = useRef(0);
  const requestKey = useRef(null);
  const invalidateReview = () => {setReview(null);requestKey.current=null;};
  const clearTarget = () => {setStudentFutureCourseList([]);setStudentFutureCourseToogleId(null);setStudentFutureCourseToogleValue(null);setStudentFutureCourseToogle(false);invalidateReview();};
  const handleCategoryChange = (item) => {if(inFlight.current)return;setTypeToogle(false);if(String(item.id)===String(typeToogleId))return;catalogVersion.current++;setTypeToogleValue(item.label);setTypeToogleId(item.id);clearTarget();};
  const handleStudentCourseChange = (item) => {if(inFlight.current)return;setStudentCourseToogle(false);if(String(item.course_id)===String(studentCourseToogleId))return;catalogVersion.current++;setStudentCourseToogleValue(item.course_title);setStudentCourseToogleId(item.course_id);clearTarget();};
  const handleFutureCourseChange = (item) => {if(inFlight.current)return;setStudentFutureCourseToogle(false);setStudentFutureCourseToogleValue(item.course_title);setStudentFutureCourseToogleId(item.course_id);invalidateReview();};
  const handleCancel = () => {
    if(inFlight.current)return;
    catalogVersion.current++;setChangeCourseModal(false);setSelectDate("");setTypeToogleValue(null);setTypeToogleId(null);setStudentCourseToogleId(0);setStudentCourseToogleValue(null);setStudentFutureCourseToogleId(null);setStudentFutureCourseToogleValue(null);setStudentFutureCourseList([]);setTypeToogle(false);setStudentCourseToogle(false);setStudentFutureCourseToogle(false);invalidateReview();
  };
  const endpoint = (action) => {const query=new URLSearchParams({f:action,status:"Active",login_user_id:localStorage.getItem("session_user_id")||"",login_action_type:localStorage.getItem("session_user_type")||"",school_id:localStorage.getItem("session_school_id")||"",login_cookie:localStorage.getItem("session_user_login_cookie")||""});return `${process.env.REACT_APP_API_BASE_URL}/?${query}`;};
  const courseDateInZurich = (date = new Date()) => {const parts=new Intl.DateTimeFormat("en",{timeZone:"Europe/Zurich",year:"numeric",month:"2-digit",day:"2-digit"}).formatToParts(date);const value=(type)=>parts.find(part=>part.type===type).value;return `${value("year")}-${value("month")}-${value("day")}`;};
  const getChangeCourseDetails = async () => {try{const response=await axios.post(endpoint("courseSwitchRequests"));if(response.data.status!==true){setData({data:[]});return;}setData(response.data);}catch(error){toast.error("The course change list could not be loaded. Please refresh.");}};
  useEffect(() => {getChangeCourseDetails();}, []);
  useEffect(() => {
    if(!ChangeCourseModal)return;
    const version=++catalogVersion.current;let active=true;setCatalogLoading(true);
    const form=new FormData();
    axios.post(`${endpoint("courseSwitchOptions")}&category=${typeToogleId||0}&current_course_id=${studentCourseToogleId||0}`,form).then(response=>{
      if(!active||version!==catalogVersion.current)return;
      if(response.data.status!==true){setStudentCourseList([]);setStudentFutureCourseList([]);toast.error(response.data.message||"Please sign in again.");return;}
      setStudentCourseList(response.data.mycourses||[]);setStudentFutureCourseList(response.data.allcourses||[]);
    }).catch(error=>{if(active&&version===catalogVersion.current){setStudentFutureCourseList([]);toast.error("Course choices could not be loaded. Please try again.");}}).finally(()=>{if(active&&version===catalogVersion.current)setCatalogLoading(false);});
    return()=>{active=false;};
  },[ChangeCourseModal,typeToogleId,studentCourseToogleId]);
  const postChangCourseDetails = async (e) => {
    e.preventDefault();if(inFlight.current)return;
    const source=studentCourseList.find(item=>String(item.course_id)===String(studentCourseToogleId));
    const target=studentFutureCourseList.find(item=>String(item.course_id)===String(studentFutureCourseToogleId));
    if(catalogLoading||!selectDate||!typeToogleId||!source||!target||String(source.course_id)===String(target.course_id)){toast.info("Please select a date, category, your current main course and one different target course.");return;}
    if(!requestKey.current)requestKey.current=window.crypto?.randomUUID?.()||`kw_${Date.now()}_${Math.random().toString(36).slice(2)}_${Math.random().toString(36).slice(2)}`;
    const form=new FormData();form.append("request_deadline",selectDate);form.append("course_id",studentCourseToogleId);form.append("future_course_id",studentFutureCourseToogleId);form.append("request_key",requestKey.current);if(review)form.append("review_hash",review.review_hash);
    inFlight.current=true;setSubmitting(true);
    try{
      const response=await axios.post(endpoint(review?"addRequest":"previewCourseSwitch"),form);
      if(response.data.status!==true){setReview(null);toast.error(response.data.message||"The course change was not saved.");return;}
      if(response.data.code==="course_change_preview"){setReview(response.data);return;}
      toast.success(response.data.message||"Your request has been saved.");inFlight.current=false;handleCancel();await getChangeCourseDetails();
    }catch(error){toast.error("The result could not be confirmed. Refresh the request list before trying again.");}
    finally{inFlight.current=false;setSubmitting(false);}
  };

  return (
    <>
      {ChangeCourseModal ? (
        <div className="protokoll_section">
          <div className="container-fluid">
            <div className="user_detail">
              <div className="protokoll_title">
                <h2>CHANGE COURSE</h2>
                <div className="alert alert-danger mt-2" role="alert">
                  ⚠ Please note that the course change must be completed no later than the start date of the new course. If you wish to attend a higher-level course, please discuss it with your main teacher first to ensure that it is the right level for you. <br />Thank you.
                </div>
              </div>
            </div>
            <div className="protokoll_card">
              <div className="protokoll_card_inner">
                <div className="protokoll_form">
                  <form className="row" onSubmit={postChangCourseDetails}>
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                      <label htmlFor="inputDate" className="form-label">
                        Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="inputDate"
                        value={selectDate}
                        disabled={submitting}
                        min={courseDateInZurich()}
                        max={courseDateInZurich(new Date(new Date().setFullYear(new Date().getFullYear() + 100)))}
                        onChange={(e) => { if(inFlight.current)return; setSelectDate(e.target.value); invalidateReview(); }}
                        onClick={(e) => { e.target.showPicker?.() }}
                      />
                    </div>
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                      <label htmlFor="inputCategory" className="form-label">
                        Category
                      </label>
                      <div className="type-select">
                        <button
                          className={`btn dropdown-toggle4 ${typeToogle && "show"}`}
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          disabled={submitting} onClick={() => setTypeToogle(!typeToogle)}
                        >
                          {typeToogleValue === null ? "Select Category" : typeToogleValue}
                        </button>
                        <ul className={`dropdown-menu ${typeToogle && "show"}`}>
                          {typeList?.length > 0 ? (
                            typeList?.map((item, index) => (
                              <li key={index}>
                                <Link
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleCategoryChange(item);
                                  }}
                                >
                                  {item.label || ""}
                                </Link>
                              </li>
                            ))
                          ) : (
                            <li className="dropdown-item">No options</li>
                          )}
                        </ul>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                      <label htmlFor="inputStudentCourse" className="form-label">
                        Student Course
                      </label>
                      <div className="type-select">
                        <button
                          className={`btn dropdown-toggle4 ${studentCourseToogle && "show"}`}
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          disabled={submitting || catalogLoading} onClick={() => setStudentCourseToogle(!studentCourseToogle)}
                        >
                          {studentCourseToogleValue === null ? "Select Course" : studentCourseToogleValue}
                        </button>
                        <ul className={`dropdown-menu ${studentCourseToogle && "show"}`}>
                          {studentCourseList?.length > 0 ? (
                            studentCourseList?.map((item, index) => (
                              <li key={index}>
                                <Link
                                  className="dropdown-item"
                                  href="#"
                                  onClick={() => handleStudentCourseChange(item)}
                                >
                                  {item?.course_title || ""}
                                </Link>
                              </li>
                            ))
                          ) : (
                            <li className="dropdown-item">No options</li>
                          )}
                        </ul>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                      <label htmlFor="inputStudentFutureCourse" className="form-label">
                        Student Future Course
                      </label>
                      <div className="type-select">
                        <button
                          className={`btn dropdown-toggle4 ${studentFutureCourseToogle && "show"}`}
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          disabled={submitting || catalogLoading || !studentCourseToogleId || !typeToogleId} onClick={() => setStudentFutureCourseToogle(!studentFutureCourseToogle)}
                        >
                          {studentFutureCourseToogleValue === null ? "Select Future Course" : studentFutureCourseToogleValue}
                        </button>
                        <ul className={`dropdown-menu ${studentFutureCourseToogle && "show"}`}>
                          {studentFutureCourseList?.length > 0 ? (
                            studentFutureCourseList?.map((item, index) => (
                              <li key={index}>
                                <Link
                                  className="dropdown-item"
                                  href="#"
                                  onClick={() => handleFutureCourseChange(item)}
                                >
                                  {item?.course_title || ""}
                                </Link>
                              </li>
                            ))
                          ) : (
                            <li className="dropdown-item">No options</li>
                          )}
                        </ul>
                      </div>
                    </div>
                    {review && <div className="alert alert-info" role="status"><strong>Review main-course change</strong><div>{review.review.source_course} → {review.review.target_course}</div><div>Change date: {review.review.date} · First lesson: {review.review.first_lesson}</div><div>{review.review.mode === "new_unpaid" ? "Your old subscription has ended. A new unpaid subscription entry will be opened; no payment is confirmed." : `The remaining paid subscription will be transferred through ${review.review.remaining_end}.`}</div>{review.review.request_status === "Clarification" && <div>A level change must first be reviewed by the team.</div>}<div>This submits a request; completion is shown in your request list.</div></div>}
                    <div className="d-flex justify-content-start gap-3">
                      <button type="button" disabled={submitting} className="btn btn_primary" onClick={handleCancel}>
                        Cancel
                      </button>
                      <button type="submit" disabled={submitting || catalogLoading} className="btn btn_primary">
                        {submitting ? "Please wait…" : review ? "Confirm request" : "Review request"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="task_section">
          <div className="container-fluid">
            <div className="user_detail">
              <div className="task_title text-center justify-content-between align-items-center flex-wrap d-flex">
                <h2>Change Course List</h2>
                <div>
                  <Link className="btn btn_primary" to={{ search: "?new=1" }}>
                    Change Course
                  </Link>
                </div>
              </div>
            </div>
            <div className="task_inner">
              <div className="task_table">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Main Course</th>
                        <th>Change Course</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.data?.length ? (
                        data?.data?.map((course) => (
                          <tr key={course.request_id}>
                            <td>{course?.request_deadline}</td>
                            <td>{course?.main_course_title}</td>
                            <td>{course?.future_course_title}</td>
                            <td>{course?.display_status || course?.request_status}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4}>No Change Courses Available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChangeCourse;